// Shared handoff key: the command bar stashes an un-runnable request
// here, and the Agent Workspace reads it on mount to prefill its
// composer. Nothing auto-sends — the operator still hits Send inside a
// thread. Kept in its own module so both the shell command bar and the
// route surface reference ONE constant (no drift).
export const AGENT_PREFILL_KEY = 'sc-agent-prefill'

/** Read + clear the pending command-bar request, if any. */
export function takeAgentPrefill(): string | null {
  try {
    const v = window.sessionStorage.getItem(AGENT_PREFILL_KEY)
    if (v) window.sessionStorage.removeItem(AGENT_PREFILL_KEY)
    return v && v.trim() ? v : null
  } catch {
    return null
  }
}
